import styled from 'styled-components';

export const AccordionContainer = styled.div`
  border-bottom: 1px solid #ccc;
  height: fit-content;
`;

export const AccordionHeader = styled.div`
  padding: 1rem;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AccordionContent = styled.div<{ $opened: boolean }>`
  max-height: ${({ $opened }) => ($opened ? '100vh' : '0')};
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.75s ease;
  &::after {
    content: '';
    display: block;
    padding-bottom: 2rem;
  }
`;

export const AccordionIcon = styled.span<{ $opened: boolean }>`
  font-size: 1.5rem;
  transform: ${({ $opened }) => ($opened ? 'rotate(-90deg)' : 'rotate(0deg)')};
  transition: all 0.2s ease-in-out;
`;
